import { render, staticRenderFns } from "./ProductList24TshirtV3.vue?vue&type=template&id=992f0bcc&scoped=true"
import script from "./ProductList24TshirtV3.vue?vue&type=script&lang=js"
export * from "./ProductList24TshirtV3.vue?vue&type=script&lang=js"
import style0 from "./ProductList24TshirtV3.vue?vue&type=style&index=0&id=992f0bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992f0bcc",
  null
  
)

export default component.exports